import React, { useState, useEffect, useRef, SetStateAction, Dispatch } from "react";
import {
    Box,
    TextField,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Stack,
    Tooltip,
    Typography,
    Menu,
    MenuItem,
    CircularProgress,
    styled,
    Paper,
    Popper, // Import CircularProgress
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CachedIcon from "@mui/icons-material/Cached";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import variables from "../../../assets/styles/variables.module.scss";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import TypingIndicator from "../../../Shared-ui/SharedComponents/TypingIndicator";
import PlaygroundMenu from "./PlaygroundMenu";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LogoIcon from "../../../assets/images/logo-icon.png";
import parse from "html-react-parser";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import { MessageOld, QueryOld } from "../../../Shared-ui/Types/OldPlayground";
import { JsonToTable } from "react-json-to-table";

interface MyComponentProps {
    messages: MessageOld[]
    knowledgeBase: OldAgent | undefined
    handleClickPrompt: (promptName: string) => void
    handleSendMessage: () => void
    uploadFiles: (selectedFile: File[]) => void
    typing: boolean
    setQuestionData: Dispatch<SetStateAction<QueryOld>>
}

const PlaygroundWindow: React.FC<MyComponentProps> = (props) => {

    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const divRef = React.useRef<HTMLInputElement>();
    const [scrollPercentage, setScrollPercentage] = useState(0);
    const chatEndRef = React.createRef<HTMLInputElement>();
    const textFieldRef = useRef<any | null>(null);
    const [userQuery, setUserQuery] = useState<string>("")
    const [showDownloadBtn, setShowDownloadBtn] = useState<boolean>(false)

    useEffect(() => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [props.messages]);


    useEffect(() => {
        textFieldRef.current?.focus();
    }, [textFieldRef.current]);

    const displayMessage = (message: MessageOld) => {
        try {
            let content
            content = parse(message.text ? message.text : '')
            return content
        } catch (error) {
            console.log("error occured to disaply message!", message)
            return "error occured to disaply message!"
        }
    }

    const handleSendMessage = () => {
        try {
            setUserQuery("")
            props.handleSendMessage()
            textFieldRef.current?.focus();
        } catch (err) {
            console.log(err)
        } finally {
            textFieldRef.current?.focus();

        }
    }
    const handleClickPrompt = (promptNmae: string) => {
        try {
            setUserQuery("")
            props.handleClickPrompt(promptNmae)
            textFieldRef.current?.focus();
        } catch (err) {
            console.log(err)
        } finally {
            textFieldRef.current?.focus();
        }
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files ? Array.from(event.target.files) : [new File([], "")]
        props.uploadFiles(selectedFile)
    };

    const setTextInputRef = (element: any) => {
        textFieldRef.current = element;
    };


    const onchangeQuestion = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setUserQuery(value);
        props.setQuestionData((preVal) => ({ ...preVal, query: value }));
    };


    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen((prevOpen) => !prevOpen);
    };

    const handleScroll = () => {
        if (divRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = divRef.current;
            const scrolled = (scrollTop / (scrollHeight - clientHeight)) * 100;
            setScrollPercentage(scrolled);
        }
    };

    const handleCopyText = (text: string) => {
        navigator.clipboard.writeText(text);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        // Detect "Enter" key press
        if (e.key === "Enter") {
            if (e.shiftKey) {
                // Allow Shift + Enter to create a new line
                return;
            } else {
                // Prevent Enter from creating a new line and send the message
                e.preventDefault();
                if (!props.typing) handleSendMessage();
            }
        }
    };
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    // height: "calc(100vh - 340px)",
                    height: "100%",
                    width: "100%",
                    border: "1px solid",
                    borderRadius: "30px",
                    overflow: "hidden",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                    borderColor: "rgba(24, 24, 27, .1)",
                }}
            >
                <Box
                    position="static"
                    sx={{
                        backgroundColor: "#fff",
                        borderBottom: "1px solid #f9f7f7",
                        px: 4,
                        py: 1.5,
                        //height: "45px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        boxShadow: "0 15px 30px 0 rgba(256, 256, 256, 1)",
                        zIndex: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                            }}
                        >
                            <img
                                src={LogoIcon}
                                alt="Company Logo"
                                style={{ width: 35, height: "auto" }}
                            />
                        </Box>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Chat
                        </Typography>
                    </Box>
                    <IconButton>
                        <CachedIcon />
                    </IconButton>
                </Box>

                <Box
                    sx={{
                        flexGrow: 1,
                        overflowY: "auto",
                        padding: 2,
                        pointerEvents: open ? "none" : "",
                        backgroundColor: "#fff",
                        height: "calc(100vh - 400px)",
                        "&::-webkit-scrollbar": {
                            width: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "rgba(0, 0, 0, 0.2)",
                            borderRadius: "3px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            //backgroundColor: "red",
                        },
                        "&::-webkit-scrollbar-track": {
                            //backgroundColor: "#f1f1f1",
                        },
                    }}
                    onScroll={handleScroll} // Trigger on scroll 
                    ref={divRef}
                >
                    <List>
                        {/* welcome message */}
                        <ListItem
                            key={"welcome"}
                            sx={{
                                justifyContent: "flex-start",
                                textAlign: "left",
                                "&:hover": {
                                    color: "inherit", // Remove background change on hover
                                },
                            }}
                        >
                            <ListItemText
                                primary={
                                    `Hi, I am ${props?.knowledgeBase?.name}, How can I assist you today?`
                                    // message.text 
                                }
                                primaryTypographyProps={{ fontSize: "14px" }}
                                sx={{
                                    flex: "inherit",
                                    backgroundColor: "#f2f9fa",
                                    color: variables.textColor,
                                    borderRadius: "20px 20px 20px 0px",
                                    padding: "15px",
                                    marginBottom: 0.5,
                                    maxWidth: "80%",
                                    marginLeft: "0",
                                    marginRight: "auto",
                                    display: "inline-block",
                                    minHeight: "24px",
                                    wordBreak: "break-word",
                                    whiteSpace: "pre-wrap",
                                    textAlign: "left",

                                    "& *": {
                                        whiteSpace: "pre-wrap"
                                    },

                                }}
                            />

                        </ListItem>
                        {/* welcome message  end*/}

                        {/* message array */}
                        {props.messages.map((message, index) => (
                            <ListItem
                                key={index}
                                sx={{
                                    justifyContent:
                                        message.type === "outgoing" ? "flex-end" : "flex-start",
                                    textAlign: message.type === "outgoing" ? "right" : "left",
                                    "&:hover": {
                                        color: "inherit", // Remove background change on hover
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                    }}
                                >


                                    {/* Display outgoing text */}

                                    {message.type == "outgoing" && (<>
                                        <ListItemText
                                            primary={
                                                message.text
                                            }
                                            primaryTypographyProps={{ fontSize: "14px" }}
                                            sx={{
                                                backgroundColor: variables.primaryColor,
                                                color: variables.whiteColor,
                                                borderRadius: "20px 20px 0px 20px",
                                                padding: "15px",
                                                marginBottom: 0.5,
                                                maxWidth: "80%",
                                                marginLeft: "auto",
                                                marginRight: "0",
                                                display: "inline-block",
                                                minHeight: "24px",
                                                wordBreak: "break-word",
                                                whiteSpace: "pre-wrap",
                                                textAlign: "left",
                                            }}
                                        />



                                    </>)}
                                    {/* Display incoming text */}

                                    {message.type == "incoming" && (<>
                                        <ListItemText
                                            primary={
                                                displayMessage(message)
                                                // !props.isTableResult && message.text ?
                                                //     parse(message.text) :
                                                //     < JsonToTable json={message.text} />



                                                // message.text ? parse(message.text) : ''
                                                // message.text 
                                            }
                                            primaryTypographyProps={{ fontSize: "14px" }}
                                            sx={{
                                                backgroundColor: "#f2f9fa",
                                                color: variables.textColor,
                                                borderRadius: "20px 20px 20px 0px",
                                                padding: "15px",
                                                marginBottom: 0.5,
                                                maxWidth: "80%",
                                                marginLeft: "0",
                                                marginRight: "auto",
                                                display: "inline-block",
                                                minHeight: "24px",
                                                wordBreak: "break-word",
                                                whiteSpace: "pre-wrap",
                                                textAlign: "left",

                                                "& *": {
                                                    whiteSpace: "pre-wrap",
                                                    overflow: "auto",
                                                },
                                                "table": {
                                                    border: "1px solid #ddd", // Remove background change on hover
                                                    overflow: "auto",
                                                },
                                                "& th, & td": {
                                                    padding: "8px", // Adds padding to the cells
                                                    border: "1px solid #ddd", // Adds border to each cell
                                                    wordBreak: "normal",
                                                    whiteSpace: "nowrap",
                                                },
                                                // Styling odd rows
                                                "& tr:nth-of-type(odd)": {
                                                    backgroundColor: "#e0f7fa", // Light blue background for odd rows
                                                },
                                                // Remove background color from the header row
                                                "& th": {
                                                    backgroundColor: "#f2f9fa", // Text color in the header
                                                },
                                                "& .json-to-table": {
                                                    overflow: "auto",
                                                },
                                                "& .json-to-table td": {
                                                    wordBreak: "normal",
                                                    whiteSpace: "nowrap",
                                                }
                                            }}
                                        />
                                    </>)}

                                    {/* Display attached file */}
                                    {message.type === "file" && (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                                mt: 1,
                                                background: variables.primaryColor,
                                                width: "250px",
                                                marginLeft: "auto",
                                                p: 2,
                                                borderRadius: "20px 20px 0px 20px",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "50%",
                                                    background: variables.whiteColor,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <DescriptionOutlinedIcon
                                                    fontSize="small"
                                                    sx={{ color: variables.primaryColor }}
                                                />
                                            </Box>
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    color: variables.whiteColor,
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    width: "140px",
                                                }}
                                            >
                                                {message?.file?.name || "name not found"}
                                            </Typography>
                                        </Box>
                                    )}

                                    {/* Copy Button */}
                                    {message.type === "incoming" && (
                                        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                                            <Tooltip title="Copy to clipboard">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleCopyText(message.text || "")}
                                                >
                                                    <ContentCopyIcon fontSize="inherit" />
                                                </IconButton>
                                            </Tooltip>
                                            {props.knowledgeBase?.prompts &&
                                                props.knowledgeBase?.prompts?.length > 0 && (
                                                    <Box>
                                                        <Tooltip title="Show prompts">
                                                            <IconButton
                                                                size="small"
                                                                aria-label="more"
                                                                id="long-button"
                                                                aria-controls={open ? "long-menu" : undefined}
                                                                aria-expanded={open ? "true" : undefined}
                                                                aria-haspopup="true"
                                                                onClick={handleClick}
                                                            >
                                                                <MoreVertIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </Tooltip>

                                                        <PlaygroundMenu
                                                            open={open}
                                                            setOpen={setOpen}
                                                            anchorEl={anchorEl}
                                                            scrollPercentage={scrollPercentage}
                                                            prompts={props.knowledgeBase?.prompts || []}
                                                            handleClickPrompt={handleClickPrompt}
                                                        />
                                                    </Box>
                                                )}
                                        </Box>
                                    )}
                                </Box>
                            </ListItem>
                        ))}

                        {/*  show loader for agent result */}
                        {props.typing && (
                            <Box
                                sx={{
                                    backgroundColor: "#f2f9fa",
                                    color: variables.textColor,
                                    borderRadius: "20px 20px 20px 0px",
                                    padding: "15px",
                                    marginBottom: 0.5,
                                    maxWidth: "80%",
                                    marginLeft: 2,
                                    marginRight: "auto",
                                    display: "inline-block",
                                    minHeight: "24px",
                                }}
                            >
                                <TypingIndicator />
                            </Box>
                        )}

                        <div ref={chatEndRef} />
                    </List>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "16px",
                        backgroundColor: "#ffffff",
                        borderTop: "1px solid #efeeee",
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="flex-end"
                        spacing={1}
                        sx={{ flexGrow: 1 }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                maxHeight: "100px",
                                overflow: "auto",
                                "&::-webkit-scrollbar": {
                                    width: "6px",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                                    borderRadius: "3px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                    //backgroundColor: "red",
                                },
                                "&::-webkit-scrollbar-track": {
                                    //backgroundColor: "#f1f1f1",
                                },
                            }}
                        >
                            <TextField
                                inputProps={{
                                    style: { fontSize: 14 },
                                }}
                                size="small"
                                fullWidth
                                placeholder="Type your message..."
                                value={userQuery}
                                onChange={(e) => onchangeQuestion(e)}
                                onKeyPress={handleKeyDown}
                                inputRef={setTextInputRef}
                                multiline
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        border: "none",
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                }}
                            />
                        </Box>
                        {/* <IconButton size="small" component="label">
            <QuestionMarkIcon fontSize="inherit" />
          </IconButton> */}
                        <IconButton component="label" disabled={props.typing}>
                            <AttachFileIcon />
                            <input type="file" hidden onChange={(e) => handleFileChange(e)} accept=".txt,.doc,.docx,.xls,.xlsx,.csv,.pdf,.jpg,.png" />
                        </IconButton>
                        <IconButton
                            color="primary"
                            disabled={!userQuery || props.typing ? true : false}
                            onClick={() => handleSendMessage()}
                            sx={{
                                backgroundColor: variables.primaryButton,
                                "&:hover": {
                                    backgroundColor: variables.primaryColor,
                                },
                                borderRadius: "8px",
                                px: 1.5,
                                "&.Mui-disabled": {
                                    backgroundColor: variables.primaryButton,
                                    opacity: 0.5,
                                },
                            }}
                        >
                            <SendIcon sx={{ color: "#fff" }} />
                        </IconButton>
                    </Stack>
                </Box>
            </Box>
        </>
    )
}

export default PlaygroundWindow